<div class="background-container text-center">
  <img src="../../assets/images/background/karsten-wurth-UbGYPMbMYP8-unsplash.jpg" alt="Description of Image" class="background-image">
  <div class="text-overlay">
    <h1>{{ farm.name }}</h1>
    <p><fa-icon class="me-2 fa-sm" [icon]="faLocationDot"></fa-icon>{{ farm.address }}</p>
    <div class="button-container mt-3">
      <button class="btn btn-custom" (click)="subscribeToFarm()"><fa-icon class="me-2" [icon]="faEnvelope"></fa-icon>Naroči se</button>
      <button class="btn btn-custom" (click)="openContactFarmModal()"><fa-icon class="me-2" [icon]="faMessage"></fa-icon>Kontakt</button>
    </div>
  </div>
</div>


<div class="container p-4 navbar-container">
  <div class="d-flex flex-wrap justify-content-around mb-4 gumbi">
    <button class="btn navbar-button" (click)="currentSection = 'farm'">Osebni podatki</button>
    <button class="btn navbar-button" (click)="currentSection = 'employees'">Zaposleni</button>
    <button class="btn navbar-button" (click)="currentSection = 'products'">Ponudba</button>
    <button class="btn navbar-button" (click)="currentSection = 'map'">Lokacija</button>
    <button class="btn navbar-button" (click)="currentSection = 'calendar'">Koledar</button>
    <button class="btn navbar-button" *ngIf="adminMode" (click)="currentSection = 'statistics'">Statistike</button>
  </div>

  <div class="text-center m-0">
    <img src="../../assets/images/background/splitLine.png" alt="Split Line" class="split-line-image img-fluid">
  </div>
</div>


<!-- Content Sections -->
<div [ngSwitch]="currentSection"  style="padding-bottom: 300px;">
  <ng-container *ngSwitchCase="'farm'">
    <!-- Farm Information Content Here -->
     <div class="farm-container">
    <div class="container p-4">
      <div class="card-body">
        <form *ngIf="isFarmEditMode; else viewFarmInfoMode">
          <div class="row">
            <!-- Left Column - Description -->
            <div class="col-md-6">
              <div class="p-3 mb-3 bg-success text-white rounded">
                <label for="farmDescription" class="form-label">Opis:</label>
                <textarea class="form-control description-text" id="farmDescription" [(ngModel)]="farm.description" name="farmDescription" rows="8"></textarea>
              </div>
            </div>
            <!-- Right Column - Other Data -->
            <div class="col-md-6">
              <div class="form-row mb-3">
                <label for="farmName" class="col-sm-4 col-form-label">Ime:</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" id="farmName" [(ngModel)]="farm.name" name="farmName">
                </div>
              </div>
              <div class="form-row mb-3">
                <label for="farmAddress" class="col-sm-4 col-form-label">Naslov:</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" id="farmAddress" [(ngModel)]="farm.address" name="farmAddress">
                </div>
              </div>
              <div class="form-row mb-3">
                <label for="farmPhone" class="col-sm-4 col-form-label">Telefon:</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" id="farmPhone" [(ngModel)]="farm.phone" name="farmPhone">
                </div>
              </div>
              <div class="form-row mb-3">
                <label for="farmEmail" class="col-sm-4 col-form-label">Email:</label>
                <div class="col-sm-8">
                  <input type="email" class="form-control" id="farmEmail" [(ngModel)]="farm.email" name="farmEmail">
                </div>
              </div>
              <div class="form-group text-right">
                <button type="button" class="btn btn-success mr-2 rounded-pill" (click)="saveFarm()">Shrani</button>
                <button type="button" class="btn btn-secondary rounded-pill" (click)="toggleFarmEditMode()">Prekliči</button>
              </div>
            </div>
          </div>
        </form>
        <ng-template #viewFarmInfoMode>
          <div class="row">
            <!-- Left Column - Description -->
            <div class="col-md-6">
              <div class="p-3 mb-3 bg-success gradient-background text-white rounded">
                <p class="description-text"><strong>{{ farm.description }}</strong></p>
              </div>
            </div>
            <!-- Right Column - Other Data -->
            <div class="col-md-6">
              <p><fa-icon class="me-2 fa-sm" [icon]="faUser"></fa-icon><strong>Ime:</strong> {{ farm.name }}</p>
              <p><fa-icon class="me-2 fa-sm" [icon]="faLocationDot"></fa-icon><strong>Naslov:</strong> {{ farm.address }}</p>
              <p><fa-icon class="me-2 fa-sm" [icon]="faPhone"></fa-icon><strong>Telefon:</strong> {{ farm.phone }}</p>
              <p><fa-icon class="me-2 fa-sm" [icon]="faEnvelope"></fa-icon><strong>Email:</strong> {{ farm.email }}</p>
              <div class="text-right" *ngIf="adminMode">
                <button class="btn btn-success mr-2 rounded-pill" (click)="toggleFarmEditMode()">Uredi</button>
              </div>
            </div>
          </div>
          <div class="text-center m-0">
            <img src="../../assets/images/background/splitLine.png" alt="Split Line" class="split-line-image img-fluid">
          </div>
          <h3 class="d-flex align-items-center justify-content-center lime-green-button text-white rounded-pill p-3 fs-5">
            <fa-icon class="me-2 fa-lg" [icon]="faImage"></fa-icon><span>Galerija</span>
          </h3>
          <gallery class="w-100" id="gallery" [objectFit]="'contain'" [loop]="true" [items]="farmImages" (thumbClick)="onThumbClick($event)"></gallery>
          <button *ngIf="adminMode" class="btn btn-custom mt-3" (click)="openAddFarmImagesModal()"><fa-icon class="fa-lg me-2" [icon]="faPlus"></fa-icon>Dodaj slike</button>
          <button *ngIf="imageSelected && adminMode" (click)="deleteSelectedImage()" class="btn btn-custom-danger mt-3">
            <fa-icon class="fa-lg me-2" [icon]="faTrash"></fa-icon>Izbriši izbrano sliko
          </button>
        </ng-template>
      </div>
    </div>
  </div>
  </ng-container>

  <ng-container *ngSwitchCase="'employees'">
    <!-- Employees List Content Here -->
    <div class="container p-4">
      <h3 class="d-flex justify-content-center lime-green-button text-white rounded-pill p-3 fs-5">
        <fa-icon class="me-2 fa-lg" [icon]="faUsers"></fa-icon>Zaposleni
      </h3>
      <div class="employee-list">
        <div *ngFor="let employee of farm.employees; let i = index" class="employee-item card p-3 mb-3">
          <div class="row align-items-center">
            <!-- Name Column -->
            <div class="col-12 col-md-2 d-flex align-items-center mb-2 mb-md-0">
              <fa-icon class="me-3 mb-1" [icon]="faUser"></fa-icon>
              <div>
                <h5 class="mb-1">{{ employee.name }} {{ employee.surname }}</h5>
              </div>
            </div>
  
            <!-- Description Column -->
            <div 
              class="col-12" 
              [class.col-md-7]="adminMode" 
              [class.col-md-10]="!adminMode"
              mb-2 mb-md-0>
              <p class="description-text-employees mb-0">
                {{ getTruncatedDescription(employee.employeeDescription, adminMode ? 55 : 85) }}
                <span *ngIf="employee.employeeDescription.length > (adminMode ? 55 : 85)">
                  ... <a href="#" (click)="openEmployeeDetailsModal($event, employee)">Preberi več</a>
                </span>
              </p>
            </div>
  
            <!-- Action Buttons Column -->
            <div 
              class="col-12 col-md-3 d-flex align-items-center justify-content-end" 
              *ngIf="adminMode">
              <button class="btn btn-link text-secondary p-0 d-flex align-items-center me-3" (click)="openUpdateEmployeeModal(employee)">
                <fa-icon class="me-2 fa-lg" [icon]="faEdit"></fa-icon>
                Uredi
              </button>
              <button class="btn btn-danger d-flex align-items-center" (click)="removeEmployee(i, employee.employeeID)">
                <fa-icon class="me-2 fa-lg" [icon]="faTrash"></fa-icon>
                Odstrani
              </button>
            </div>
          </div> <!-- Close row div -->
        </div> <!-- Close employee-item card div -->
      </div> <!-- Close employee-list div -->
      <div class="d-flex justify-content-center" *ngIf="adminMode">
        <button class="btn btn-custom mt-3" (click)="openAddEmployeeModal()">
          <fa-icon class="me-3" [icon]="faPlus"></fa-icon>Dodaj zaposlenega
        </button>
      </div>
    </div> <!-- Close container div -->
  </ng-container>
  
  

  <ng-container *ngSwitchCase="'products'">
    <!-- Products List Content Here -->

       <app-product-list [allProducts]="products" [onMarketPage]="false" [admin]="adminMode" [farmID]="farm.farmID"></app-product-list>
  </ng-container>
  

  <ng-container *ngSwitchCase="'calendar'">
    <div class="container">

      <app-full-calendar [farmID]="farm.farmID" [admin]="adminMode"></app-full-calendar>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'statistics'">
    <div class="container">

      <app-farm-statistics-page [farm]="farm"></app-farm-statistics-page>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'map'">
    <div class="container">

      <app-map [farmLocations]="farmLocations" [inputFarmID]="farm.farmID" [interactive]="false"></app-map>
    </div>
  </ng-container>

</div>
